$(document).ready(function(){    
    
    $('.moduleGallery').each(function(){
        var module = $(this);        
        initModule(module);
    });
    
    function initModule(module) {        
        
        function switcher(item) {
            if(item.hasClass('selected')) {
                item.removeClass('selected');
            }
            else {
                module.find('.filter .tag').removeClass('selected');
                item.addClass('selected');
            }           
        }

        function getSelectedTag() {
            return module.find('.filter .tag.selected').data('tag').toString();
        }

        function filter() {        
            var selectedTag = getSelectedTag();
            if(selectedTag) {
                module.find('.grid .item').each(function(){
                    var item = $(this);
                    var itemTags = item.data('tags').split(','); 

                    if(itemTags.indexOf(selectedTag) === -1) { 
                        item.slideUp();
                    }
                    else {
                        item.slideDown();
                    }
                });                        
            }         
            else {
                module.find('.gallery .grid .item').slideDown(); 
            }        
        }  
         
        
        module.find('.filter .tag').click(function(){            
            var clickedTagEl = $(this);
            switcher(clickedTagEl);        
            filter();
        });           
    }
});

$(document).ready(function() {  
	var gallery = $('.popup-gallery');
			
	var config = {		
		//items: items,		
		delegate: 'a.lightbox',
		tLoading: 'Loading image #%curr%...',
		mainClass: 'mfp-img-mobile',		
		closeOnContentClick: true,
		showCloseBtn: true,
		closeBtnInside: false,
		closeOnBgClick: true,
		gallery: {
			enabled: true,
			navigateByImgClick: false,
			preload: [0,1] // Will preload 0 - before current, and 1 after the current image			
		},
		image: {
			tError: '<a href="%url%">The image #%curr%</a> could not be loaded.'			
		} 
	};	
	
	gallery.magnificPopup(config);
});